// @flow

import type { PropsSchema, BasicProps, JsEnv } from 'projects/easy/public/type'
import React from 'react'
import cx from 'classnames'
import { setPageTitle, setNavigationBarRightButton } from 'frame/core/app/all'
import * as browserEnv from 'frame/core/browserEnv'
import { history, location } from 'frame/core/window'
import styles from './Header.scss'
import computeData from '../hoc/computeData'
import * as FengjrApp from 'frame/core/app/fengjr'

type Props = BasicProps & {
  title: string,
  theme: 'dark' | 'white' | 'danger' | 'orange' | 'red',
  rightNavType: 'word' | 'img',
  isShowInApp: boolean,
  backMessage?: string,
  rightText?: string,
  jsEnv: JsEnv,
  rightImgUrl: ?{
    url: string,
    originWidth: number,
    originHeight: number
  },
  onClick: () => void,
  events?: Object
};

@computeData({ includeData: true, includeVisible: false })
export default class Header extends React.Component<Props> {
  handleBeforeunload: (e: any) => void;

  static schema: PropsSchema = [
    {
      key: 'title',
      title: '标题',
      type: 'text'
    },
    {
      key: 'theme',
      title: '主题',
      type: 'select',
      options: ['dark', 'white', 'danger', 'orange', 'red'],
      defaultValue: 'white'
    },
    {
      key: 'isShowInApp',
      title: '在App中显示H5标题栏',
      type: 'boolean',
      defaultValue: false
    },
    'separator',
    {
      key: 'rightNavType',
      title: '右侧导航类型',
      type: 'select',
      options: [['word', '文字'], ['img', '图片']],
      defaultValue: 'word'
    },
    {
      key: 'rightText',
      title: '导航文字',
      type: 'text',
      visible: props => props.rightNavType === 'word'
    },
    {
      key: 'rightImgUrl',
      title: '导航图片',
      type: 'image',
      visible: props => props.rightNavType === 'img'
    },
    'separator',
    {
      type: 'event',
      title: '右上角点击事件',
      event: 'rightClick'
    },
    'separator',
    {
      type: 'event',
      title: '返回按钮点击事件',
      event: 'backClick'
    }
  ];

  static defaultProps = {
    theme: 'white',
    title: ''
  };

  handelBackClick = () => {
    const { callActions } = this.props
    if (this.isExistBackClick()) {
      callActions('backClick')
      return
    }
    this.historyBack()
  };

  isExistBackClick () {
    const { events = {} } = this.props
    const { backClick = {} } = events
    const { targets = [] } = backClick
    return targets.length > 0
  }

  historyBack = () => {
    if (/\bbackToHome\b/.test(location.search)) {
      location.href = '/'
    } else {
      history.back()
    }
  };

  onClick = () => {
    this.props.callActions('rightClick')
  };

  componentDidMount = () => {
    const {
      rightImgUrl,
      jsEnv,
      rightText: oriRightText,
      callActions
    } = this.props
    const rightText = oriRightText ? jsEnv.getString(oriRightText) : ''
    if (browserEnv.isInApp()) {
      setTimeout(() => {
        setNavigationBarRightButton({
          text: rightText || '',
          image: rightImgUrl ? rightImgUrl.url : '',
          clickCallback: this.onClick
        })
        //  返回按钮拦截

        if (
          this.isExistBackClick() &&
          (browserEnv.isInFjApp() || browserEnv.isInXqkdApp())
        ) {
          FengjrApp.getNavLeftGoBackAction({
            isInterception: true,
            callBack: () => {
              callActions('backClick')
            }
          })
        }
      }, 200)
    }
  };

  render () {
    const {
      id,
      theme,
      title: oriTitle,
      jsEnv,
      rightText: oriRightText,
      rightImgUrl,
      isShowInApp
    } = this.props
    const title = jsEnv.getString(oriTitle)
    const rightText = oriRightText ? jsEnv.getString(oriRightText) : ''
    if (!isShowInApp && browserEnv.isInApp()) {
      setPageTitle(title)
      return null
    }
    return (
      <div id={id} className={cx(styles.this, styles[theme])}>
        <div className={styles.center}>{title}</div>
        <div className={styles.left} onClick={this.handelBackClick} />
        {rightText && (
          <div className={styles.right} onClick={this.onClick}>
            {rightText}
          </div>
        )}
        {rightImgUrl && (
          <img
            src={rightImgUrl.url}
            className={styles.rightIcon}
            onClick={this.onClick}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/ui/Header.js